import type { RefCallback } from 'react'

import styles from './ScrollThumb.module.scss'

/**
 * Trilho + polegar sobre um container que já esconde o scrollbar nativo
 * (classe `hideNativeScrollbar` exportada deste módulo). Renderiza `null`
 * quando o conteúdo não excede a área visível.
 *
 * A altura/posição do polegar não vêm de props reativas — `thumbRef` é
 * escrito direto pelo `useScrollThumb` a cada scroll, sem passar por
 * re-render. Só `visible` (que muda raramente) é que monta/desmonta este
 * componente. Ver o comentário em `useScrollThumb` sobre por quê.
 */
export function ScrollThumb({
  visible,
  thumbRef
}: {
  visible: boolean
  thumbRef: RefCallback<HTMLDivElement>
}) {
  if (!visible) return null

  return (
    <div className={styles.track} aria-hidden>
      <div ref={thumbRef} className={styles.thumb} />
    </div>
  )
}

export { styles as scrollThumbStyles }
